import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItem } from '../../../../spacesPlatform/models/resourceParts';
import { IDatabase } from '../../types/IDatabase';
import { IMaxDownstreamDatasources, IMaxDownstreamWorkbooks} from '../../types/IMaxDownstreamConnections';

export interface IGetDatabasesParams extends IGetItemsParams {
}

export interface IGetDatabasesResult extends IGetItemsResult {
  databases?: IDatabase[];
  containers?: INamedItem[];
  maxDownstreamDatasourcesViewModel?: IMaxDownstreamDatasources;
  maxDownstreamWorkbooksViewModel?: IMaxDownstreamWorkbooks;
}

export class GetDatabasesRequest extends Request<IGetDatabasesParams, IGetDatabasesResult> {
  constructor(params: IGetDatabasesParams) {
    super('getDatabases', params);
  }
}